import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import axios from "axios";

//axios.defaults.baseURL = "https://db.stride.pesa.solutions/api/"; //prod -in nuse pixi.db.pitch90agent.com
axios.defaults.baseURL = "https://pixi.db.pitch90agent.com/api/";
//axios.defaults.baseURL = "http://localhost:12002/api/"; //dev
// Create an Axios instance for read operations

axios.defaults.withCredentials = true;

const el = document.getElementById("root");

const root = ReactDOM.createRoot(el);

root.render(<App />);
